"use strict";

define('evisions/helper/spinner',['underscore', 'jquery', 'spin'], function (_, $, Spinner) {
  var EVIHelperSpinner = _.extend({
    spinner: {
      lines: 12,
      length: 20,
      width: 10,
      radius: 30,
      corners: 1,
      rotate: 0,
      direction: 1,
      color: '#a0a0a0',
      speed: 1,
      trail: 60,
      shadow: false,
      hwaccel: false,
      className: 'spinner app-spinner',
      zIndex: 2e9,
      position: 'absolute'
    },
    createSpinner: function createSpinner(boxed, block) {
      var spinArgs = this.spinner;
      if (boxed) {
        spinArgs = $.extend({}, this.spinner, {
          color: '#ffffff'
        });
      }
      this._spinner = new Spinner(spinArgs);
      return this._spinner;
    },
    showLoading: function showLoading(parent, boxed, block) {
      var spinner = this.createSpinner(boxed, block).spin();
      if (boxed) {
        $(spinner.el).addClass('boxed');
      }
      if (block) {
        $(spinner.el).addClass('block');
      }
      parent.prepend(spinner.el);
    },
    hideLoading: function hideLoading() {
      if (this._spinner) {
        this._spinner.stop();
      }
    }
  });
  return EVIHelperSpinner;
});

